"use client"

import React from 'react'
import OrLineSeparator from '../../../../../shared/components/ui/or-line-separator'
import { useSignupFormStepsContext } from '../../../context/signup-form-steps-context'
import GoogleAuthButton from '../../google-auth-button'
import SuceessSignupForm1 from './sucess-sign-up-form-1'
import SucessSignUpFormNavigator from './sucess-sign-up-form-navigator'

function SucessSignupForm() {
    const { currentStep } = useSignupFormStepsContext()
    return (
        <div className='flex flex-col gap-5'>
            <GoogleAuthButton />
            <OrLineSeparator />
            {currentStep.number === 1 && <SuceessSignupForm1 /> }
            <SucessSignUpFormNavigator />
        </div>
        
    )
}

export default SucessSignupForm